import { BaseSlugData } from '@openticket/lib-sdk-helpers';

export function errorToSlugData(
    errorType: 'timeout' | 'failed' | 'unexpected' | 'invalid'
): BaseSlugData {
    switch (errorType) {
        case 'timeout':
            return {
                key:
                    'shop.components.deferred_place_order.error.poll_limit_reached',
            };

        case 'failed':
            return {
                key:
                    'shop.components.deferred_place_order.error.order.buffered',
            };

        case 'unexpected':
            return {
                key:
                    'shop.components.deferred_place_order.error.order.buffered',
            };

        case 'invalid':
            return {
                key: 'shop.components.deferred_place_order.error.order.invalid',
            };
    }
}

export function validationError(
    validationType: 'shopid' | 'token'
): BaseSlugData {
    switch (validationType) {
        case 'shopid':
            return {
                key:
                    'shop.components.deferred_place_order.error.shop_id.invalid',
            };
        case 'token':
            return {
                key:
                    'shop.components.deferred_place_order.error.identifier.invalid',
            };
    }
}
